module.exports = __webpack_public_path__ + "static/media/assembly_line.5ad2dd2f.png";